<template>
    <div class="fixedscreen-el" v-if="screenEl">
        <div class="main__blck">
            <div class="closed" @click="screenEl = !screenEl">
                <img src="../../../../img/icon/Close-black.svg" alt="">
            </div>
            <p class="relawaySM med p-black">Try to win Xiaomi M365 pro</p>
            <p class="min-min">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
            <img src="../../../../img/Scooter.png" alt="">

        </div>
    </div>
</template>

<script>
    export default {
        name: "fixedAdEl",
        data: function(){
            return {
                top: 0,
                screenEl: true
            }
        },
        methods: {
            handleResize(){
                console.log(window.scrollY);
            }
        },
        created() {
            window.addEventListener('scroll', this.handleResize);
            this.handleResize();
        },
    }
</script>

